const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC_ID_PATTERN = /^\d+$/;
const OPAQUE_ID_PATTERN = /^(?=.*\d)[A-Za-z0-9_-]{16,}$/;
// A long unbroken alphanumeric run marks a real opaque token/hash; route slugs
// are separator-joined short words (e.g. "funds-2024-q1-summary"), so they have
// no such run and are left intact.
const HAS_UNBROKEN_RUN = /[A-Za-z0-9]{12,}/;

const isIdSegment = (segment: string): boolean =>
  NUMERIC_ID_PATTERN.test(segment) ||
  UUID_PATTERN.test(segment) ||
  (OPAQUE_ID_PATTERN.test(segment) && HAS_UNBROKEN_RUN.test(segment));

export const sanitiseEndpoint = (
  url: string | undefined,
  baseURL?: string,
): string | undefined => {
  if (!url) return undefined;

  let path = url;

  try {
    const resolved = new URL(url, baseURL ?? "http://placeholder.invalid");
    path = resolved.pathname;
  } catch {
    path = url.split("?")[0].split("#")[0];
  }

  const sanitisedSegments = path
    .split("/")
    .map((segment) => (isIdSegment(segment) ? ":id" : segment));

  return sanitisedSegments.join("/");
};
